import { useEffect, useRef, useState } from "react";
import { APP_VERSION } from "../version";

const DEFAULT_INTERVAL_MS = 5 * 60 * 1000;

// Polls the static /version.json manifest (regenerated on every build, see
// scripts/generate-version-file.js) and compares it against the version this
// bundle was built with. Since the app is a CRA SPA on S3/CloudFront with no
// service worker, this is how a running tab learns a new build was deployed.
export function useVersionCheck(intervalMs = DEFAULT_INTERVAL_MS) {
    const [newVersion, setNewVersion] = useState(null);
    const checking = useRef(false);

    useEffect(() => {
        async function checkVersion() {
            if (checking.current || newVersion) {
                return;
            }
            checking.current = true;
            try {
                const res = await fetch(`/version.json?_=${Date.now()}`, {
                    cache: "no-store",
                });
                if (res.ok) {
                    const data = await res.json();
                    if (data.version && data.version !== APP_VERSION) {
                        setNewVersion(data.version);
                    }
                }
            } catch (e) {
                // Transient network/offline errors are expected; just retry
                // on the next interval.
            } finally {
                checking.current = false;
            }
        }

        checkVersion();
        const interval = setInterval(checkVersion, intervalMs);

        const onVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                checkVersion();
            }
        };
        document.addEventListener("visibilitychange", onVisibilityChange);

        return () => {
            clearInterval(interval);
            document.removeEventListener(
                "visibilitychange",
                onVisibilityChange
            );
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [intervalMs]);

    return newVersion;
}
